<template>
  <div id="capacitacion2">
    <head>
      <link href="https://vjs.zencdn.net/7.5.4/video-js.css" rel="stylesheet">
    </head> 

    <!-- Computadora -->      
      <v-dialog class="hidden-sm-and-down"
        v-model="dialog"
        width="850"
      >
        <v-img slot="activator" @click.stop="dialog=true" src="video.png" class="playvideo" width="150%" ><span style="opacity:0">NoNO</span></v-img>      
        <v-card style="border-radius:10px" class="pb-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  fab flat color="#B4347E" small @click="dialog = false">
              <v-icon x-large>cancel</v-icon>
            </v-btn>
          </v-card-actions>        
        <v-card-title 
          class="headline white lighten-2"
          primary-title
          style="color:grey;font-family:Poppins!important;font-size:1.8vw;font-weight:400; margin-left:10px"
        > 
          {{capacitacion_data.title}}     
        </v-card-title>        
        <div align="center">         
          <video-player2 ref="player"  :options="videoOptions"/>
        </div>
        <v-layout row wrap justify-center="">
        </v-layout>
        </v-card>
    </v-dialog>

  <!--Movil -->

  <v-dialog class="hidden-md-and-up"
        v-model="dialog2"
        width="350"
      >
        <v-img slot="activator" @click.stop="dialog2=true" src="video.png" class="playvideo" width="150%" ><span style="opacity:0">NoNO</span></v-img>      
        <v-card style="border-radius:10px" class="pb-3">
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn  fab flat color="#B4347E" small @click="dialog2 = false">
              <v-icon x-large>cancel</v-icon>
            </v-btn>
          </v-card-actions>        
        <v-card-title 
          class="headline white lighten-2"
          primary-title
          style="color:grey;font-family:Poppins!important;font-size:1.8vw;font-weight:400; margin-left:10px"
        > 
          {{capacitacion_data.title}}     
        </v-card-title>        
        <div align="center">         
          <VideoPlayer2 ref="player"  :options="videoOptionsMovil"/>
        </div>
        <v-layout row wrap justify-center="">
        </v-layout>
        </v-card>
    </v-dialog>


  </div>
</template>

<script>
import VideoPlayer2 from "@/components/VideoPlayer.vue"
let capacitacion_data;

export default {
  props:['capacitacion'],
  components:{
    VideoPlayer2
  },
  data(){
     capacitacion_data = Object.assign({}, capacitacion_data, this.capacitacion);
      return{
        state:false,
        isLesson:false,
        capacitacion_data,        
        dialog:false,
        dialog2:false,
        videoOptions:{
          poster: capacitacion_data.img,
          autoplay:false,
          controls:true,
          preload:'auto',
          width:800,
          sources:[
            {
              src:capacitacion_data.url,
              type: "video/mp4"                
            }
          ]
        },
        videoOptionsMovil:{
          poster: capacitacion_data.img,
          autoplay:false,
          controls:true,
          preload:'auto',
          width:300,
          sources:[
            {
              src:capacitacion_data.url,
              type: "video/mp4"                
            }
          ]
        },
      }
  },
  mounted(){    
    capacitacion_data.url
  },
  methods: {
    
    cerrar: function(){
          this.$refs.player.playerClose()
          this.dialog=false;
        } ,
  },


  watch: {
    dialog(val){
      !val&&this.$refs.player.playerClose();
    }
  }
}


</script>

<style>
.playvideo:hover{
  transform: scale(1.2);
}


</style>
